<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="queryOnLoad" :onConfigReady="onQueryConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <div class="simple-row" v-if="showAddFlag">
            <div class="left">
                <div class="swb-btn swb-btn-small" @click="addServcTypeCharge()">
                    <span>新增</span>
                </div>
            </div>
        </div>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'

    import userApi from '../../api/user'
    import servcOperApi from '../../api/servcOper'
    import servcCategApi from '../../api/servcCateg'
    import { getDefaultPageSizes } from '../../../src/app.conf'
    import { openServcTypeChargeItemListSaveDlg } from './selectDlg'

    import SwbServcCatChargeItemSave from './ServcTypeChargeItemSave';
    Vue.regist(SwbServcCatChargeItemSave);

    export default {
        name: 'swb-servc-type-charge-item-list-select',
        props: ['servcTypeId', "selectIds", "showAddFlag"],
        desc: '服务类型收费项目',
        data: function () {
            return {
                confKey: "swb-servc-type-charge-item-list",
                queryOnLoad: true,
                // 分页信息
                theTableHeight: 500,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: true, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）

                btnColName: '',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 200,//操作列宽度（默认：100）
                                 //
                btnColFixed: true, //操作列是否固定
                //
                pageSize: getDefaultPageSizes().first(),
                pageNumber: 1,
                // 过滤信息
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
            }
        },
        created(){
            //
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.theTableHeight = height;
            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('[name="query-sort-block"], .simple-row'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
            //
            this.handleInitChecked();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            onQueryConfigReady: function (event) {
                if(Utils.isNoB(this.servcTypeId)) {
                    let servcTypeList = getEnumList("servcType");
                    if(!Utils.isNoB(servcTypeList) && servcTypeList.length > 0) {
                        let dataList = [];
                        dataList.push({"value": null, "label": "-全部-"});
                        servcTypeList.forEach(function (item) {
                            dataList.push({
                                value: item.value,
                                label: item.text
                            });
                        });
                        this.updateQueryModelField("servcTypeId", dataList);
                    }
                } else {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let fieldInfo = {
                        servcTypeId: {
                            hidden: true
                        }
                    };
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if(itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'actions': function (row, colName, colValue, rowIndex) {
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                    }
                });
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getDataList();
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getDataList();
            },
            //回显数据处理
            handleInitChecked() {
                let resultTable = this.$refs.result_table;
                let selectIds = this.selectIds || [];
                resultTable.setInitChecked(selectIds);
            },
            getDataList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                if(!Utils.isNoB(this.servcTypeId)) {
                    filterItems.servcTypeId = this.servcTypeId;
                }
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoad = MsgBox.loading();
                servcOperApi.getServcTypeChargeItemList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let dataList = result.data.rows || [];
                        self.totalCount = result.data.pagination.totalCount;
                        self.renderTable(dataList, result.data.pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            addServcTypeCharge: function () {
                let self = this;
                openServcTypeChargeItemListSaveDlg(this.servcTypeId, function (result, theDlg) {
                    let postData = result || {};
                    let theLoad = MsgBox.loading();
                    servcOperApi.saveServcTypeChargeItemBatch(postData, function (resultData) {
                        theLoad.hide();
                        if(resultData.type == "info") {
                            theDlg.close();
                            MsgBox.success("新增成功");
                            //
                            self.getDataList();
                        } else {
                            MsgBox.warning(resultData.message);
                        }
                    })
                })
            },
            getDlgResult: function () {
                let selectList = this.getTableSelection() || [];
                //
                let result = {
                    type: 'info',
                    data: selectList
                };
                return result;
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/compo/categ/ServcTypeChargeItemListSelect.vue